import React from 'react';

import { useAuth0 } from '@auth0/auth0-react';
import { Spinner } from 'src/components/Spinner';

export default function Index() {
  const {isLoading, isAuthenticated }= useAuth0();

  if (isLoading) {
    return <Spinner />
  }

  return (
    <div className="uk-margin \
          uk-margin uk-margin-left uk-margin-right" >
      <div className="uk-align-left uk-grid" >
        <div className="uk-align-left">
          <h2>
            Welcome to the Sesame Serial Tracker
          </h2>
          {!isAuthenticated &&
            <h3>
              Log in to get started
           </h3>
          }
        </div>
      </div>
    </div>
  );
}
